import React, { Component } from "react";
import { Link } from "react-router-dom";
import Panel from "../../../UI/Panel";
import PanelBody from "../../../UI/Panel/PanelBody";
import PageSubTitle from "../../../UI/PageSubTitle";
import ReactPhoneInput from "react-phone-input-2";
export default class MobileNumber extends Component {
  state = { mobile: "" };
  render() {
    const { mobile } = this.state;
    return (
      <Panel>
        <PanelBody>
          <PageSubTitle center>
            <h3>Mobile Number</h3>
            <p>You can choose to hide it in your privacy.</p>
          </PageSubTitle>
          <div className="input-group">
            <div className="input-group-btn text-center">
              <Link
                to={{
                  pathname: "/profile",
                  state: { openModal: true }
                }}
                className="btn btn-warning btn-sm "
              >
                Update
              </Link>
            </div>
          </div>
        </PanelBody>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/Home/Update/MobileNumber/index.js